import PropTypes from "prop-types";

const RentalDurationToggle = ({ checked, onChange }) => {
  const copyContent = checked
    ? "before:content-['4_Days'] after:content-['8_Days'] before:border-darkerGray before:pr-20"
    : "before:content-['8_Days'] after:content-['4_Days'] before:border-lighterGray before:pl-20";

  const dataTestId = checked ? "rental-duration-8-days" : "rental-duration-4-days";

  const toggleContent = `${copyContent} bg-white peer-checked:bg-white before:border before:rounded-full after:w-1/2 before:px-3 after:px-3 before:py-2 after:py-2 before:inline-block after:inline-block before:normal-case after:normal-case before:flex before:items-center after:flex after:items-center before:text-darkGray after:text-white before:text-center after:text-center before:h-6 after:h-6 after:top-0 after:start-0 after:bg-wine`;

  return (
    <label className={`flex flex-row items-center tracking-normal mb-0`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className="sr-only peer"
        data-test-id={dataTestId}
        aria-label="Rental Duration Toggle"
      />
      <div
        className={`relative ${toggleContent} rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full  after:absolute after:rounded-full after:transition-all`}></div>
    </label>
  );
};

RentalDurationToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RentalDurationToggle;
